import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-slate-100 border-t border-slate-200 py-12 px-4" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-209">
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-210">
            📚 RESCATE ACADÉMICO™
          </h3>
          <p className="text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-211">
            El sistema N°1 para estudiantes de Kinesiología que quieren aprobar,
            dominar la clínica y recibirse en tiempo.
          </p>
          <p className="text-slate-600 italic max-w-2xl mx-auto" data-id="element-212">
            "Porque estudiar Kinesiología no debería costarte todas tus noches y
            fines de semana buscando información dispersa."
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-slate-600 pt-6" data-id="element-213">
            <span data-id="element-214">📧 [tu email]</span>
            <span className="hidden md:inline" data-id="element-215">·</span>
            <span data-id="element-216">📲 @RescateAcademico</span>
            <span className="hidden md:inline" data-id="element-217">·</span>
            <span data-id="element-218">🌐 [tu web]</span>
          </div>

          <div className="border-t border-slate-300 pt-6 mt-6" data-id="element-219">
            <p className="text-slate-500 text-sm" data-id="element-220">
              © 2025 Rescate Académico™
            </p>
            <p className="text-slate-500 text-xs mt-2" data-id="element-221">
              Prohibida la reproducción sin autorización.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>;
}